import { render, staticRenderFns } from "./index.vue?vue&type=template&id=bd0f4d7e&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=bd0f4d7e&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=bd0f4d7e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0f4d7e",
  null
  
)

export default component.exports